import React, { useEffect, useState, createContext, useContext } from 'react';
import { User, Role } from '../data/types';
import { USERS } from '../data/mockData';
interface AuthContextType {
  user: User | null;
  login: (role: Role) => void;
  logout: () => void;
  isAuthenticated: boolean;
}
const AuthContext = createContext<AuthContextType | undefined>(undefined);
export function AuthProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [user, setUser] = useState<User | null>(null);
  // Check local storage on mount
  useEffect(() => {
    const storedUser = localStorage.getItem('coolerpulse_user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);
  const login = (role: Role) => {
    const mockUser = USERS.find(u => u.role === role);
    if (mockUser) {
      setUser(mockUser);
      localStorage.setItem('coolerpulse_user', JSON.stringify(mockUser));
    }
  };
  const logout = () => {
    setUser(null);
    localStorage.removeItem('coolerpulse_user');
  };
  return <AuthContext.Provider value={{
    user,
    login,
    logout,
    isAuthenticated: !!user
  }} data-id="element-150">
      {children}
    </AuthContext.Provider>;
}
export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}